/** Leaves the portal for Microsoft. One function so tests can replace it (jsdom cannot navigate). */
export const redirect = {
  to(url: string): void {
    window.location.assign(url);
  },
};

export function goTo(url: string): void {
  redirect.to(url);
}
